<template>
  <div class="header"
       v-show="FullScreenShow">
    <!-- 折叠按钮 -->
    <!--<div class="collapse-btn" @click="collapseChage">-->
    <!--<i v-if="!silderToggle" class="el-icon-s-fold"></i>-->
    <!--<i v-else class="el-icon-s-unfold"></i>-->
    <!--</div>-->
    <div class="logo">
      <!-- 标序云仓管理后台 -->
      <!--<breadCrumb></breadCrumb>-->
      <img src="@/assets/images/logo.png">

    </div>
    <div class="merchantInfo"
         v-if="merchantManageInfo.yctName"
         @click="openMerchant">
      <span>{{merchantManageInfo.yctName}}</span>
      <img src="@/assets/images/header/right.png">
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 进入数据中心 -->
        <div v-if="hasDataCenterPermis" class="enter-dataCenter-btn" @click="$router.push('/dataCenter/dataHome')">数据中心</div>
        <!-- 全屏显示 -->
        <div class="btn-fullscreen"
             @click="handleFullScreen">
          <el-tooltip effect="dark"
                      :content="fullscreen?`取消全屏`:`全屏`"
                      placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <!-- 消息中心 -->
        <!--<div class="btn-bell">-->
        <!--<el-tooltip-->
        <!--effect="dark"-->
        <!--:content="message?`有${message}条未读消息`:`消息中心`"-->
        <!--placement="bottom"-->
        <!--&gt;-->
        <!--<router-link to="/tabs">-->
        <!--<i class="el-icon-bell"></i>-->
        <!--</router-link>-->
        <!--</el-tooltip>-->
        <!--<span class="btn-bell-badge" v-if="message"></span>-->
        <!--</div>-->
        <!-- 用户头像 -->
        <div class="user-avator">
          <!--<img src="../../assets/img/img.jpg" />-->
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name"
                     trigger="click"
                     @command="handleCommand">
          <span class="el-dropdown-link">
            {{username}}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">修改密码</el-dropdown-item>
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="修改密码"
                   :visible.sync="dialogVisible"
                   width="45%"
                   :before-close="handleClose">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-form-item prop="acount"
                          label="账号:">
              <el-input :disabled="true"
                        v-model="ruleForm.acount"></el-input>
            </el-form-item>
            <el-form-item prop="password"
                          label="输入新密码:">
              <el-input placeholder="请输入新密码"
                        v-model="ruleForm.password"
                        show-password></el-input>
            </el-form-item>
            <el-form-item prop="passwordcm"
                          label="确认新密码:">
              <el-input placeholder="请输入确认新密码"
                        v-model="ruleForm.passwordcm"
                        show-password></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer"
                class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="submitForm('ruleForm')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
// import bus from '../common/bus';
import breadCrumb from '../components/Breadcrumb'
import { SLIDERTOGGLE, EDITPASSWARD } from '../store/toggle/types'
import merchantManage from '@/store/merchantManage/index'
import { SHOWTENANT } from '@/store/merchantManage/types.js'
import { LOGOUT } from '@/store/user/types.js'
// import { SETDATACENTERPERMIS } from '@/store/user/types.js'

import toggle from '../store/toggle/index'
import user from '../store/user/index'

export default {
  data () {
    return {
      collapse: false,
      fullscreen: false,
      name: '用户名',
      message: 2,
      dialogVisible: false,
      ruleForm: {
        acount: localStorage.getItem('accout'),
        password: '',
        passwordcm: ''
      },
      // 表单校验
      rules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        passwordcm: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { required: false, trigger: 'blur', validator: this.userPassWord }
        ]
      }
    }
  },
  components: {
    breadCrumb
  },
  computed: {
    hasDataCenterPermis () {
      return !!((user.state.dataCenterPermis && user.state.dataCenterPermis.length))
    },
    silderToggle () {
      return toggle.state.sliderToggle
    },
    username () {
      // let username = localStorage.getItem('ms_username') ? localStorage.getItem('ms_username') : this.name
      return user.state.userinfo.user ? user.state.userinfo.user.name : this.name
    },
    // 是否开启全屏
    FullScreenShow () {
      return user.state.FullScreenShow
    },
    // 标识
    editMask () {
      return toggle.state.editMask
    },
    merchantManageInfo () {
      return merchantManage.state.merchantInfo
    }
  },
  watch: {
    editMask: {
      deep: true,
      handler (val) {
        if (val === 1) {
          toggle.state.editMask = 0
          this.handleClose()
        }
      }
    }
  },
  methods: {
    // 用户名下拉菜单选择事件
    handleCommand (command) {
      if (command === 'loginout') {
        // localStorage.removeItem('ms_username');
        this.$store.dispatch(LOGOUT)
        user.state.dataCenterPermis = []
      } else if (command === 'edit') {
        this.dialogVisible = true
        this.ruleForm = {
          acount: localStorage.getItem('accout'),
          password: '',
          passwordcm: ''
        }
      }
    },
    // 关闭弹窗
    handleClose () {
      this.dialogVisible = false
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate()
      }
    },
    // 提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm
          let params = {
            password: data.password
          }
          this.$store.dispatch(EDITPASSWARD, params)
        } else {
          return false
        }
      })
    },
    // 侧边栏折叠
    collapseChage () {
      this.$store.dispatch(SLIDERTOGGLE, !this.silderToggle)
      // this.collapse = !this.collapse;
      // bus.$emit('collapse', this.collapse);
    },
    // 全屏事件
    handleFullScreen () {
      let element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    // 密码校验
    userPassWord (rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    openMerchant () {
      this.$router.push('/merchantManage/merchantInfo/')
    }
  },
  mounted () {
    if (document.body.clientWidth < 1500) {
      this.collapseChage()
    }
    let params = {}
    this.$store.dispatch(SHOWTENANT, params)
  }
}
</script>
<style scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  font-size: 22px;
  color: #fff;
}
.collapse-btn {
  float: left;
  padding: 0 21px;
  cursor: pointer;
  line-height: 70px;
}
.header .logo {
  float: left;
  width: 210px;
  margin-left: 17px;
  margin-top: 28px;
}
.header .merchantInfo {
  float: left;
  font-size: 40px;
  color: #ffffff;
  border-left: 1px #fff solid;
  margin: 30px 0 30px 40px;
  padding-left: 40px;
  cursor: pointer;
}
.header .logo img {
  width: 100%;
}
.header-right {
  float: right;
  padding-right: 50px;
}
.header-user-con {
  display: flex;
  height: 100px;
  align-items: center;
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.btn-fullscreen i{
  vertical-align: middle;
}
.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-name {
  margin-left: 10px;
}
.user-avator {
  margin-left: 20px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: center;
}
.enter-dataCenter-btn{
  border: 1px solid #25c2de;
  color: #1ed8f1;
  font-size: 13px;
  padding: 3px 5px;
  border-radius: 4px;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/layout/Header.vue